import {Component, OnInit} from '@angular/core';
import {BaseView} from '../../../../../../core/view/base.view';
import {SaleInvoiceModel} from '../../../api/entity/saleInvoice.model';
import {IDialogComponent} from '../../../../../../common/dialog/iDialog.component';
import {DialogWithInput} from '../../../../../../common/dialog/dialogWithInput';

export interface SaleInvoiceSaveDialogInput {
    id?: number;
    saleId?: number;
    hideManualDocumentUpload: boolean;
}

export interface SaleInvoiceSaveDialogResult {
    created: boolean;
    entity: SaleInvoiceModel;
}

@Component({
    templateUrl: './sale-invoice-save-dialog.page.html',
})
export class SaleInvoiceSaveDialogPage extends BaseView implements
    IDialogComponent<SaleInvoiceSaveDialogInput, SaleInvoiceSaveDialogResult>, OnInit {

    dialog: DialogWithInput<SaleInvoiceSaveDialogInput, SaleInvoiceSaveDialogResult>;

    constructor() {
        super();
    }

    ngOnInit(): void {
    }

    saved(entity: SaleInvoiceModel) {
        this.dialog.close({
            created: !this.dialog.input.id,
            entity
        });
    }
}
